<template>
	<div>
		<committee-collaboration-evaluation :read-only="true"/>
	</div>
</template>

<script>
	import CommitteeCollaborationEvaluation from "./CommitteeCollaborationEvaluation";

	export default {
		name: "ReadOnlyCommitteeCollaborationEvaluation",
		components: {CommitteeCollaborationEvaluation},
	};
</script>

<style scoped>

</style>
